import { Component } from "react";
import { selectFieldStyle, selectFieldStyleError } from "@utils/const";
import { tableCellAutorizado, tableCellNegado } from "@utils/const";
import { FormGroup, FormControl } from "react-bootstrap";
import { Form, Table, Button } from "semantic-ui-react";
import { getProcedimentos, getProcedimentosFiltro } from "@store/actions/index";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { removeAccents } from "@utils/stringUtil";
import { connect } from "react-redux";
import CustomSnackbar from "./../shared/custom_snackbar";
import NumericInput from "react-numeric-input";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import CemigModal from "../shared/cemigModal";
import Select from "react-select";
import m from "@utils/strings";
import _ from "lodash";
import "@styles/exames-procedimentos.css";

class FormProcedimentos extends Component {
  constructor(props) {
    super(props);

    this.reference = this;

    this.state = {
      procedimentoSelecionado: "",
      procedimentos: [],
      numberInputSelecionado: 1,
      procedimentosTableRows: [],
      procedimentosExamesTableRows: [],
      procedimentosListados: [],
      mapeamentoNumericInputProcedimento: [],
      procedimentosToRender: [],
      indicacaoClinica: "",
      indicacaoClinicaNormal: "",
      hasSubmitted: false,
      showModalIndicacaoClinica: false,
      showModalIndicacaoClinicaNormal: false,
      showModalProcedimentoNegado: false,
      procedimentosSavedOnModal: {},
      hideForm: false,
      blockFields: false,
      blockAddProcedimentoEnter: false,
    };

    this.procedimentosNumberInputsReferences = {};
    this.hideNumberInputDiv = {};
    this.hideRemoverButton = {};

    this.focus = this.focus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.parcialmenteAutorizadoResponseStatus =
      this.parcialmenteAutorizadoResponseStatus.bind(this);
    this.handleSetInitialFieldsStateProcedimento =
      this.handleSetInitialFieldsStateProcedimento.bind(this);
  }

  componentDidMount() {
    this.loadInputDatas();
    this.props.blockAllFields(this.blockAllFields);
    this.props.focusFirstFieldProcedimentos(this.focus);
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.setInitialFieldsState(
      this.handleSetInitialFieldsStateProcedimento
    );
    this.props.parcialmenteAutorizadoResponseStatus(
      this.parcialmenteAutorizadoResponseStatus
    );
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey && charCode === "v") {
      console.log(event);
      console.log(this.textInput.state);
    } else if (event.key === "Enter" && this.state.hideForm) {
      this.props.resetAllStates();
    } else if (
      event.key === "Enter" &&
      this.props.activeAccordion === "3" &&
      !this.state.blockAddProcedimentoEnter
    ) {
      event.preventDefault();
      this.addProcedimentoToTheList();
    }
  }

  focus() {
    setTimeout(() => {
      this.textInput.focus();
    }, 1000);
  }

  loadInputDatas = () => {};

  onProcedimentoSelectChange = (inputValue) => {
    inputValue = removeAccents(inputValue.toUpperCase());

    if (inputValue.length < 3) {
      this.setState({
        procedimentosToRender: [],
      });
    } else {
      // Se não tiver o texto na lista, deverá buscar na api
      let contensInputProcedimento =
        (this.state.procedimentosToRender ?? []).filter((m) => {
          return removeAccents(m.label.toUpperCase()).includes(
            removeAccents(inputValue.toUpperCase())
          );
        })?.length > 0;

      if (
        !contensInputProcedimento ||
        (this.state.procedimentosToRender ?? []).length === 0
      ) {
        this.props.getProcedimentosFiltro(inputValue, (result) => {
          let arrayToRender = (result?.data ?? []).map((procedimento) => {
            return {
              value: procedimento,
              label: `${procedimento.Codigo} - ${procedimento.Descricao}`,
            };
          });

          this.setState({
            procedimentos: result.data,
            procedimentosToRender: arrayToRender,
          });
        });
      }
    }
  };

  parcialmenteAutorizadoResponseStatus(procedimentosExames, statusExame) {
    this.setState({ hideForm: true });
    this.updateProcedimentosExamesTable(procedimentosExames, statusExame);
  }

  procedimentoSelect = (event) => {
    this.setState({ procedimentoSelecionado: event });
  };

  numberInputSelect = (event) => {
    event = event < 0 ? this.state.numberInputSelecionado : event;
    event = event > 999 ? this.state.numberInputSelecionado : event;
    this.setState({ numberInputSelecionado: event });
  };

  disableProcedimentosList = () => {
    for (let key in this.hideNumberInputDiv) {
      if (this.hideNumberInputDiv[key] != null)
        this.hideNumberInputDiv[key].style = "pointer-events: none";
    }
    for (let key in this.hideRemoverButton) {
      if (this.hideRemoverButton[key] != null)
        this.hideRemoverButton[key].style = "pointer-events: none";
    }
  };

  blockAllFields = () => {
    if (!this.state.hideForm) this.disableProcedimentosList();
    this.setState({ blockFields: true });
  };

  updateProcedimentosExamesTable = (procedimentosExames, statusExame) => {
    let index = 0;
    let tableRows = procedimentosExames.map((procedimentoExame) => {
      let statusProcedimento;
      switch (statusExame) {
        case "AUTORIZADO":
          statusProcedimento = "Autorizado";
          break;
        case "EM ANÁLISE":
          if (procedimentoExame.quantidadeAutorizada > 0) {
            statusProcedimento = "Autorizado";
          } else {
            statusProcedimento = "Em análise";
          }
          break;
        case "NEGADO":
          statusProcedimento = "Negado";
          break;
        case "AUTORIZADO PARCIALMENTE":
          if (procedimentoExame.quantidadeAutorizada == 0) {
            statusProcedimento = "Negado";
          } else {
            statusProcedimento = "Autorizado";
          }
          break;
      }
      index++;
      return (
        <Table.Row key={index}>
          <Table.Cell className={"td-procedimento-item"}>
            <div
              style={
                procedimentoExame.QuantidadeAutorizada ==
                procedimentoExame.QuantidadeSolicitada
                  ? {}
                  : { color: "#DF1F36" }
              }
            >
              {`${procedimentoExame.Codigo} - ${procedimentoExame.Descricao}`}
            </div>
          </Table.Cell>
          <Table.Cell>
            <div
              style={
                procedimentoExame.QuantidadeAutorizada ==
                procedimentoExame.QuantidadeSolicitada
                  ? {}
                  : { color: "#DF1F36" }
              }
            >
              {procedimentoExame.QuantidadeSolicitada}
            </div>
          </Table.Cell>
          <Table.Cell>
            <div
              style={
                procedimentoExame.QuantidadeAutorizada ==
                procedimentoExame.QuantidadeSolicitada
                  ? {}
                  : { color: "#DF1F36" }
              }
            >
              {procedimentoExame.QuantidadeAutorizada}
            </div>
          </Table.Cell>
          <Table.Cell>
            <img
              src="../images/alert-circle.png"
              alt="Requer"
              style={{
                display:
                  procedimentoExame.CodigoMotivoGlosa &&
                  procedimentoExame.CodigoMotivoGlosa.includes("1427")
                    ? "inline"
                    : "none",
              }}
              title={
                m.TELA_EXAMES_PROCEDIMENTOS
                  .MENSAGEM_TOOLTIP_REQUER_AUDITORIA_DEPOIS_AUTORIZAR
              }
            />
          </Table.Cell>
          <Table.Cell>
            <div
              style={
                procedimentoExame.QuantidadeAutorizada ==
                procedimentoExame.QuantidadeSolicitada
                  ? tableCellAutorizado
                  : tableCellNegado
              }
            >
              {statusProcedimento}
            </div>
          </Table.Cell>
          <Table.Cell>
            <img
              src="../images/alert-motivo.png"
              alt="Possui"
              style={{
                display: !_.isEmpty(procedimentoExame.descricaoMotivoGlosa)
                  ? "inline"
                  : "none",
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({
                  showModalProcedimentoNegado:
                    !this.state.showModalProcedimentoNegado,
                });
                this.setState({
                  procedimentoNegado: {
                    Procedimento: `${procedimentoExame.Codigo} - ${procedimentoExame.Descricao}`,
                    QuantidadeSolicitada:
                      procedimentoExame.QuantidadeSolicitada,
                    QuantidadeAutorizada:
                      procedimentoExame.QuantidadeAutorizada,
                    Codigo: procedimentoExame.CodigoMotivoGlosa,
                    Justificativa: procedimentoExame.DescricaoMotivoGlosa,
                    Status: statusProcedimento,
                  },
                });
              }}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    this.setState({ procedimentosExamesTableRows: tableRows });
  };

  addProcedimentoToTheList = () => {
    this.setState({
      hasSubmitted: true,
      procedimentos: [],
      procedimentosToRender: [],
    });

    if (
      !_.isEmpty(this.state.procedimentoSelecionado) &&
      this.state.numberInputSelecionado &&
      this.state.numberInputSelecionado > 0
    ) {
      let procedimento = this.state.procedimentoSelecionado.value;
      let number = this.state.numberInputSelecionado;

      let willAddAnotherProcedimento = true;
      this.state.procedimentosListados.forEach((procedimentoListado) => {
        if (procedimentoListado.procedimento.Codigo == procedimento.Codigo) {
          //este procedimento ja esta listado
          willAddAnotherProcedimento = false;
        }
      });

      if (willAddAnotherProcedimento) {
        let mapeamentoArray = this.state.mapeamentoNumericInputProcedimento;
        mapeamentoArray.push({
          numericInputValue: number,
          codigoProcedimento: procedimento.Codigo,
        });
        this.setState({ mapeamentoNumericInputProcedimento: mapeamentoArray });

        let newRow = this.state.procedimentosTableRows;
        let jsxRow = (
          <Table.Row key={procedimento.Codigo}>
            <Table.Cell
              className={"td-procedimento-item"}
            >{`${procedimento.Codigo} - ${procedimento.Descricao}`}</Table.Cell>
            <Table.Cell>
              <div
                ref={(div) => {
                  this.hideNumberInputDiv[
                    `numericInput${procedimento.Codigo}`
                  ] = div;
                }}
              >
                <NumericInput
                  className="form-control input"
                  id={procedimento.Codigo}
                  style={{ input: { width: 65 } }}
                  readOnly={this.state.blockFields}
                  ref={(input) => {
                    this.procedimentosNumberInputsReferences[
                      `numericInput${procedimento.Codigo}`
                    ] = input;
                  }}
                  value={this.state.numberInputSelecionado}
                  onChange={(value, a, input) => {
                    let mapeamentoArray =
                      this.state.mapeamentoNumericInputProcedimento.map(
                        (obj) => {
                          if (obj.codigoProcedimento == input.id) {
                            if (value > 999) value = obj.numericInputValue;
                            if (value <= 0) value = obj.numericInputValue;

                            this.procedimentosNumberInputsReferences[
                              `numericInput${input.id}`
                            ].setState({ value: value });
                            this.procedimentosNumberInputsReferences[
                              `numericInput${input.id}`
                            ].setState({ stringValue: value.toString() });

                            return {
                              codigoProcedimento: obj.codigoProcedimento,
                              numericInputValue: value,
                            };
                          } else {
                            return obj;
                          }
                        }
                      );
                    this.setState({
                      mapeamentoNumericInputProcedimento: mapeamentoArray,
                    });
                  }}
                />
              </div>
            </Table.Cell>
            <Table.Cell>
              <img
                src="../images/alert-circle.png"
                alt="Requer"
                id={procedimento.Codigo}
                style={{
                  display: procedimento.Requerauditoria ? "inline" : "none",
                }}
                title={
                  m.TELA_EXAMES_PROCEDIMENTOS
                    .MENSAGEM_TOOLTIP_REQUER_AUDITORIA_ANTES_AUTORIZAR
                }
              />
            </Table.Cell>
            <Table.Cell>
              <img
                src="../images/x.png"
                alt="Apagar"
                id={procedimento.Codigo}
                ref={(imgRef) =>
                  (this.hideRemoverButton[
                    `numericInput${procedimento.Codigo}`
                  ] = imgRef)
                }
                style={
                  this.state.blockFields
                    ? { display: "none" }
                    : { cursor: "pointer" }
                }
                onClick={(a) => {
                  let procedimentosTableRowsUpdate =
                    this.state.procedimentosTableRows.filter((procedimento) => {
                      if (procedimento.key === a.target.id) return false;
                      else return true;
                    });
                  let procedimentosListadosUpdate =
                    this.state.procedimentosListados.filter(
                      (procedimentoListado) => {
                        if (
                          procedimentoListado.procedimento.Codigo == a.target.id
                        )
                          return false;
                        else return true;
                      }
                    );
                  this.setState({
                    procedimentosListados: procedimentosListadosUpdate,
                  });
                  this.setState({
                    procedimentosTableRows: procedimentosTableRowsUpdate,
                  });
                }}
              />
            </Table.Cell>
          </Table.Row>
        );
        newRow.push(jsxRow);

        let addProcedimentoList = this.state.procedimentosListados;
        addProcedimentoList.push({ procedimento: procedimento });

        this.setState({ procedimentosListados: addProcedimentoList });
        this.setState({ procedimentosTableRows: newRow });

        this.setState({ numberInputSelecionado: 1 });
        this.setState({ procedimentoSelecionado: "" });

        this.clickInserir();
      } else {
        this.clickInserirRepetido();
      }
    } else {
      if (!_.isEmpty(this.state.numberInputSelecionado))
        this.setState({ numberInputSelecionado: 1 });
      if (_.isEmpty(this.state.procedimentoSelecionado))
        this.setState({ procedimentoSelecionado: "" });
      this.focus();
    }
  };

  handleSubmit = (event) => {
    let listagemProcedimentosRetorno = {};
    listagemProcedimentosRetorno.procedimentos =
      this.state.procedimentosListados.map((procedimento) => {
        let quantidade = 0;
        this.state.mapeamentoNumericInputProcedimento.forEach((obj) => {
          if (obj.codigoProcedimento == procedimento.procedimento.Codigo)
            quantidade = obj.numericInputValue;
        });
        return {
          ...procedimento.procedimento,
          quantidade: quantidade,
        };
      });
    listagemProcedimentosRetorno.indicacaoClinica = "";

    let requerPeloMenosUmaAuditoria = false;
    listagemProcedimentosRetorno.procedimentos.forEach((procedimento) => {
      if (procedimento.Requerauditoria) requerPeloMenosUmaAuditoria = true;
    });

    if (requerPeloMenosUmaAuditoria) {
      this.setState({
        showModalIndicacaoClinica: !this.state.showModalIndicacaoClinica,
      });
      this.setState({
        procedimentosSavedOnModal: listagemProcedimentosRetorno,
      });
    } else {
      this.setState({
        showModalIndicacaoClinicaNormal:
          !this.state.showModalIndicacaoClinicaNormal,
      });
      this.setState({
        procedimentosSavedOnModal: listagemProcedimentosRetorno,
      });
    }
  };

  indicacaoClinicaUpdate = (inputText) => {
    this.setState({ indicacaoClinica: inputText });
  };

  handleSetInitialFieldsStateProcedimento = () => {
    if (this.state.hideForm) this.setState({ hideForm: false });
    this.procedimentosNumberInputsReferences = {};
    this.setState({
      procedimentoSelecionado: "",
      procedimentos: [],
      numberInputSelecionado: 1,
      procedimentosTableRows: [],
      procedimentosExamesTableRows: [],
      procedimentosListados: [],
      mapeamentoNumericInputProcedimento: [],
      procedimentosToRender: [],
      indicacaoClinica: "",
      indicacaoClinicaNormal: "",
      hasSubmitted: false,
      showModalIndicacaoClinica: false,
      showModalIndicacaoClinicaNormal: false,
      procedimentosSavedOnModal: {},
      parcialmenteAutorizadoResponseStatus: false,
      blockFields: false,
      blockAddProcedimentoEnter: false,
    });
    this.loadInputDatas();
  };

  indicacaoClinicaTextosProibidos = (textoIndicacaoClinica) => {
    let temTextoProibido = false;
    let textosProibidos = ["Em anexo", "Em anexos"];

    // Deverá comparar em caixa baixa e ignorar espaços em branco
    let findIndex = textosProibidos.findIndex((f) =>
      f
        .toLowerCase()
        .replace(/\s/g, "")
        .startsWith(textoIndicacaoClinica.toLowerCase().replace(/\s/g, ""))
    );

    if (findIndex >= 0) {
      this.props.callSnackbarFailure(
        `${m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_INDICACAO_CLINICA_TEXTO_INVALIDO}`.replace(
          "{textoProibido}",
          textosProibidos[findIndex]
        )
      );

      temTextoProibido = true;
    }

    return temTextoProibido;
  };

  indicacaoClinicaMinCaracterRequired = () => {
    let indicacaoClinicaMinCaracter = 8;
    let indicacaoRequired = false;
    let indicacaoClinica = this.state.indicacaoClinica ?? "";

    if (
      indicacaoClinica.length < indicacaoClinicaMinCaracter ||
      this.indicacaoClinicaTextosProibidos(indicacaoClinica)
    ) {
      if (indicacaoClinica.length < indicacaoClinicaMinCaracter)
        this.props.callSnackbarFailure(
          `${m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_INDICACAO_CLINICA_MINIMO_CARACTER}`.replace(
            "{caracter}",
            indicacaoClinicaMinCaracter
          )
        );

      indicacaoRequired = true;
    }

    return indicacaoRequired;
  };

  submitModalIndicacaoClinica = () => {
    if (!this.indicacaoClinicaMinCaracterRequired()) {
      this.setState({
        blockAddProcedimentoEnter: !this.state.blockAddProcedimentoEnter,
        showModalIndicacaoClinica: !this.state.showModalIndicacaoClinica,
      });

      let listagemToReturn = this.state.procedimentosSavedOnModal;
      listagemToReturn.indicacaoClinica = this.state.indicacaoClinica;

      this.props.autorizarExame(listagemToReturn);
    }
  };

  submitModalIndicacaoClinicaNormal = () => {
    if (!this.indicacaoClinicaMinCaracterRequired()) {
      this.setState({
        blockAddProcedimentoEnter: !this.state.blockAddProcedimentoEnter,
        showModalIndicacaoClinicaNormal:
          !this.state.showModalIndicacaoClinicaNormal,
      });

      let listagemToReturn = this.state.procedimentosSavedOnModal;
      listagemToReturn.indicacaoClinica = this.state.indicacaoClinica;
      this.props.autorizarExame(listagemToReturn);
    }
  };

  openSnackbar = (message, status = "success") => {
    this.setState({ snackbarMsg: message, snackbarStatus: status });
    this.click();
  };

  render() {
    let btnAutorizarDisabledStatus = !this.state.blockFields
      ? this.state.procedimentosListados.length > 0
        ? false
        : true
      : true;

    return (
      <div className="form-accordion">
        <Form>
          <Form.Group style={this.state.hideForm ? { display: "none" } : {}}>
            <Form.Field
              inline={true}
              width={10}
              disabled={this.state.blockFields}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_PROCEDIMENTO}
                </label>
              </div>
              <Select
                value={this.state.procedimentoSelecionado}
                onChange={this.procedimentoSelect}
                placeholder={
                  m.TELA_EXAMES_PROCEDIMENTOS.PLACEHOLDER_PROCEDIMENTO
                }
                onInputChange={this.onProcedimentoSelectChange}
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return m.TELA_EXAMES_PROCEDIMENTOS
                    .MENSAGEM_NENHUM_PROCEDIMENTO_ENCONTRADO;
                }}
                isDisabled={this.state.blockFields}
                ref={(input) => {
                  this.textInput = input;
                  if (this.textInput) {
                    this.textInput.select.inputRef.onpaste = (e) => {
                      this.onProcedimentoSelectChange(
                        e.clipboardData.getData("Text")
                      );
                    };
                  }
                }}
                filterOption={(field, value) => {
                  value = value.toUpperCase();
                  value = removeAccents(value);
                  field.label = field.label.toUpperCase();
                  field.label = removeAccents(field.label);
                  if (field.label.includes(value)) return true;
                  else return false;
                }}
                styles={
                  !this.state.procedimentoSelecionado &&
                  this.state.hasSubmitted &&
                  _.isEmpty(this.state.procedimentosTableRows)
                    ? selectFieldStyleError
                    : selectFieldStyle
                }
                options={this.state.procedimentosToRender}
              />
              <ErrorMsgLabel
                boolean={
                  !this.state.procedimentoSelecionado &&
                  this.state.hasSubmitted &&
                  _.isEmpty(this.state.procedimentosTableRows)
                }
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={2}
              disabled={this.state.blockFields}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_QUANTIDADE}
                </label>
              </div>
              <NumericInput
                min={1}
                max={999}
                disabled={this.state.blockFields}
                className="form-control input"
                value={this.state.numberInputSelecionado}
                id={
                  this.state.numberInputSelecionado || !this.state.hasSubmitted
                    ? "numeric-input"
                    : "numeric-input-error"
                }
                onChange={this.numberInputSelect}
              />
              <ErrorMsgLabel
                boolean={
                  !this.state.numberInputSelecionado && this.state.hasSubmitted
                }
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              width={4}
              disabled={this.state.blockFields}
            >
              <label
                onClick={this.addProcedimentoToTheList}
                id={"incluir-procedimento"}
              >
                <div
                  style={{
                    textAlign: "center",
                    fontFamily: "Work Sans",
                    marginTop: 15,
                  }}
                >
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_INCLUIR} (ENTER)
                </div>
              </label>
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <div
              className="layout-table"
              style={
                this.state.procedimentosTableRows.length > 0 &&
                !this.state.hideForm
                  ? {}
                  : { display: "none" }
              }
            >
              {/* Tabela para preencher listagem antes da autorizacao */}
              <Table striped>
                <Table.Header>
                  <Table.Row id="table-header">
                    <Table.HeaderCell id="table-header-element">
                      {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_PROCEDIMENTO}
                    </Table.HeaderCell>
                    <Table.HeaderCell id="table-header-element">
                      {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_QUANTIDADE}
                    </Table.HeaderCell>
                    <Table.HeaderCell id="table-header-element">
                      {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_REQUER_AUDITORIA}
                    </Table.HeaderCell>
                    <Table.HeaderCell id="table-header-element">
                      {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_EXCLUIR}
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{this.state.procedimentosTableRows}</Table.Body>
              </Table>
            </div>
            {/* Tabela dos procedimentos retornados pela API depois de autorizado */}

            <Button
              style={this.state.hideForm ? { display: "none" } : {}}
              onClick={this.handleSubmit}
              disabled={btnAutorizarDisabledStatus}
              className={`btn-default-cemig`}
            >
              {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_AUTORIZAR}
            </Button>
          </Form.Field>

          <div
            className="layout-table"
            style={
              this.state.procedimentosExamesTableRows.length > 0 &&
              this.state.hideForm
                ? {}
                : { display: "none" }
            }
          >
            <Table striped>
              <Table.Header>
                <Table.Row id="table-header">
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_PROCEDIMENTO}
                  </Table.HeaderCell>
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_QUANTIDADE_SOLICITADA}
                  </Table.HeaderCell>
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_QUANTIDADE_AUTORIZADA}
                  </Table.HeaderCell>
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_AUDITORIA}
                  </Table.HeaderCell>
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_SITUACAO}
                  </Table.HeaderCell>
                  <Table.HeaderCell id="table-header-element">
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_MOTIVO}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{this.state.procedimentosExamesTableRows}</Table.Body>
            </Table>
          </div>
        </Form>

        <CemigModal
          activeAccordion={this.props.activeAccordion}
          isOpened={this.state.showModalIndicacaoClinica}
          enterKeyPress={this.submitModalIndicacaoClinica}
          title={m.TELA_EXAMES_PROCEDIMENTOS.TITULO_MODAL_INDICACAO_CLINICA}
          content={
            <div>
              <div>
                <label className={"form-autorizacao-label"}>
                  {
                    m.TELA_EXAMES_PROCEDIMENTOS
                      .MENSAGEM_INFORME_INDICACAO_CLINICA
                  }
                </label>
              </div>
              <Form onSubmit={this.submitModalIndicacaoClinica}>
                <FormGroup controlId="formControlsTextarea">
                  <FormControl
                    componentClass="textarea"
                    value={this.state.indicacaoClinica}
                    onChange={(text) => {
                      this.setState({ indicacaoClinica: text.target.value });
                    }}
                    inputRef={(formText) => {
                      this.modalTextArea = formText;
                    }}
                    maxLength="500"
                    required
                  />
                </FormGroup>
                <Button
                  type="submit"
                  className={`btn-default-cemig`}
                  style={{ width: 220 }}
                >
                  {
                    m.TELA_EXAMES_PROCEDIMENTOS
                      .LABEL_CONTINUAR_INDICACAO_CLINICA
                  }{" "}
                  (ENTER)
                </Button>
              </Form>
            </div>
          }
          close={() => {
            this.setState({
              showModalIndicacaoClinica: !this.state.showModalIndicacaoClinica,
            });
          }}
          onOpenModal={() => {
            setTimeout(() => {
              if (this.modalTextArea) this.modalTextArea.focus();
            }, 500);
          }}
        />

        <CemigModal
          activeAccordion={this.props.activeAccordion}
          isOpened={this.state.showModalIndicacaoClinicaNormal}
          enterKeyPress={this.submitModalIndicacaoClinicaNormal}
          title={m.TELA_EXAMES_PROCEDIMENTOS.TITULO_MODAL_INDICACAO_CLINICA}
          content={
            <div>
              <div>
                <label className={"form-autorizacao-label"}>
                  {
                    m.TELA_EXAMES_PROCEDIMENTOS
                      .MENSAGEM_INFORME_INDICACAO_CLINICAOBRIGATORIO
                  }
                </label>
              </div>
              <Form onSubmit={this.submitModalIndicacaoClinicaNormal}>
                <FormGroup controlId="formControlsTextarea">
                  <FormControl
                    componentClass="textarea"
                    value={this.state.indicacaoClinica}
                    onChange={(text) => {
                      this.setState({ indicacaoClinica: text.target.value });
                    }}
                    inputRef={(formText) => {
                      this.modalTextArea = formText;
                    }}
                    maxLength="500"
                  />
                </FormGroup>
                <Button
                  type="submit"
                  className={`btn-default-cemig`}
                  style={{ width: 220 }}
                >
                  {
                    m.TELA_EXAMES_PROCEDIMENTOS
                      .LABEL_CONTINUAR_INDICACAO_CLINICA
                  }{" "}
                  (ENTER)
                </Button>
              </Form>
            </div>
          }
          close={() => {
            this.setState({
              showModalIndicacaoClinicaNormal:
                !this.state.showModalIndicacaoClinicaNormal,
            });
          }}
          onOpenModal={() => {
            setTimeout(() => {
              if (this.modalTextArea) this.modalTextArea.focus();
            }, 500);
          }}
        />

        <CemigModal
          activeAccordion={this.props.activeAccordion}
          isOpened={this.state.showModalProcedimentoNegado}
          title={`${m.TELA_EXAMES_PROCEDIMENTOS.LABEL_PROCEDIMENTO} ${
            this.state.procedimentoNegado != null
              ? this.state.procedimentoNegado.Status
              : ""
          }`}
          content={
            <div>
              <div className="row">
                <div className="col-sm-6">
                  <label className={"modal-label-title"}>
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_TABLE_PROCEDIMENTO}
                  </label>
                  <label className={"modal-label"}>
                    {this.state.procedimentoNegado
                      ? this.state.procedimentoNegado.Procedimento
                      : ""}
                  </label>
                </div>
                <div className="col-sm-3">
                  <label
                    className={"modal-label-title"}
                    style={{ textAlign: "center" }}
                  >
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_QUANTIDADE_SOLICITADA}
                  </label>
                  <label
                    className={"modal-label"}
                    style={{ textAlign: "center" }}
                  >
                    {this.state.procedimentoNegado
                      ? this.state.procedimentoNegado.QuantidadeSolicitada
                      : ""}
                  </label>
                </div>
                <div className="col-sm-3">
                  <label
                    className={"modal-label-title"}
                    style={{ textAlign: "center" }}
                  >
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_QUANTIDADE_AUTORIZADA}
                  </label>
                  <label
                    className={"modal-label"}
                    style={{ textAlign: "center" }}
                  >
                    {this.state.procedimentoNegado
                      ? this.state.procedimentoNegado.QuantidadeAutorizada
                      : ""}
                  </label>
                </div>
              </div>
              <div>
                <div style={{ marginTop: 15 }}>
                  <label className={"modal-label-title"}>
                    {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_JUSTIFICATIVA}
                  </label>
                  <label className={"modal-label"}>
                    {this.state.procedimentoNegado
                      ? /* ${this.state.procedimentoNegado.codigo} -  */ `${this.state.procedimentoNegado.Justificativa}`
                      : ""}
                  </label>
                </div>
              </div>
              <div style={{ marginTop: 15 }}>
                {
                  <CopyToClipboard
                    text={
                      this.state.procedimentoNegado
                        ? /* ${this.state.procedimentoNegado.codigo} -  */ `${this.state.procedimentoNegado.Justificativa}`
                        : ""
                    }
                  >
                    <label
                      onClick={() => {
                        this.openSnackbar(
                          m.MODAL.NOTIFICACAO_COPIAR_JUSTIFICATIVA,
                          "success"
                        );
                      }}
                      id={"label-copiar"}
                    >
                      {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_COPIAR}
                    </label>
                  </CopyToClipboard>
                }
              </div>
            </div>
          }
          close={() => {
            this.setState({
              blockAddProcedimentoEnter: !this.state.blockAddProcedimentoEnter,
              showModalProcedimentoNegado:
                !this.state.showModalProcedimentoNegado,
            });
          }}
        />

        <CustomSnackbar
          setClick={(click) => (this.click = click)}
          variant={this.state.snackbarStatus}
          duration={3000}
          content={this.state.snackbarMsg}
        />
        <CustomSnackbar
          setClick={(click) => (this.clickInserir = click)}
          variant="success"
          duration={2000}
          content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_INSERIR_NA_TABELA}
        />
        <CustomSnackbar
          setClick={(click) => (this.clickInserirRepetido = click)}
          variant="error"
          duration={3000}
          content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_INSERIR_REPETIDO}
        />
      </div>
    );
  }
}

export default connect(null, { getProcedimentos, getProcedimentosFiltro })(
  FormProcedimentos
);
